import _extends from "@babel/runtime/helpers/extends";
/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: eprivacy
 * Version: 7.3.0-ALPHA-3
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import React from 'react';
import AppItem from './app-item';
var AppList = function AppList(_ref) {
  var t = _ref.t,
    ns = _ref.ns,
    apps = _ref.apps,
    consents = _ref.consents,
    onToggle = _ref.onToggle;
  return /*#__PURE__*/React.createElement("ul", {
    className: ns('AppList')
  }, apps.map(function (app) {
    var checked = consents[app.name];
    var handleToggle = function handleToggle(value) {
      return onToggle(app, value);
    };
    return /*#__PURE__*/React.createElement("li", {
      key: "app-".concat(app.name),
      className: ns("AppList-item AppList-item--".concat(app.name))
    }, /*#__PURE__*/React.createElement(AppItem, _extends({
      checked: checked || app.required,
      onToggle: handleToggle,
      t: t,
      ns: ns
    }, app)));
  }));
};
export default AppList;